import { gsap }          from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const organicEffect = () => {
    ScrollTrigger.matchMedia({
        '(min-width: 1439px)' : function () {
            const organicBlock = document.querySelector('.organic__item--list');
            const section      = organicBlock?.closest('.organic');

            if (!organicBlock || !section) return;

            // Получаем высоту секции для точного расчета
            const sectionHeight = section.offsetHeight;

            gsap.set(organicBlock, { y : 0 });

            gsap.to(organicBlock, {
                scrollTrigger : {
                    trigger             : section,
                    start               : 'top 30%',           // начало: верх секции на 70% окна
                    end                 : `+=${sectionHeight * 0.3}`, // конец: через 30% высоты секции
                    scrub               : 0.5,
                    markers             : false,
                    invalidateOnRefresh : true
                },
                y    : -230,
                ease : 'none'
            });
        },

        '(max-width: 1438px)' : function () {
            const organicBlock = document.querySelector('.organic__item--list');
            if (organicBlock) {
                gsap.set(organicBlock, { y : 0 });
                ScrollTrigger.getAll().forEach((trigger) => {
                    if (trigger.vars.trigger?.contains?.(organicBlock)) {
                        trigger.kill();
                    }
                });
            }
        }
    });
};

export default organicEffect;
